import { parseAmountValue } from './parseAmountValue';
import { OrderItem } from '../types';

export function totalAmountFromItems(
  lineItems: OrderItem[],
  shippingAmount?: number | string,
  totalTaxAmount?: number | string,
): number {
  const totalAmount = lineItems
    // If quantity if 0, then we ignore
    ?.filter((item) => item.quantity !== 0)

    // Sum of unitAmount * quantity - discountAmount
    .reduce(
      (acc, item) =>
        acc +
        parseAmountValue(item.unitAmount).asNumber() *
          parseAmountValue(item.quantity ?? 1).asNumber() -
        parseAmountValue(item.discountAmount ?? 0).asNumber(),
      0,
    );

  return (
    totalAmount +
    parseAmountValue(shippingAmount ?? 0).asNumber() +
    parseAmountValue(totalTaxAmount ?? 0).asNumber()
  );
}
